import { createFileRoute } from "@tanstack/react-router";
import FAQ from "@/pages/site/FAQ";

export const Route = createFileRoute("/faq")({
  component: () => <FAQ />,
});
